export default "__VITE_ASSET__2a8b7248__"